import React from "react"

// tslint:disable-next-line:no-big-function
export const LevelIcon04 = (): JSX.Element => (
	<svg
		width="100%"
		height="100%"
		viewBox="0 0 1000 1000"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		fillRule="evenodd"
		clipRule="evenodd"
		strokeLinecap="round"
		strokeLinejoin="round"
		strokeMiterlimit="1.5"
		fill="none"
	>
		<g transform="matrix(1,0,0,1,-3149.29,0)">
			<g transform="matrix(1,0,0,1,3149.29,0)">
				<g>
					<g transform="matrix(1.47701,-0.852755,0.852755,1.47701,-664.885,108.808)">
						<path
							className="badge-color-3-fill"
							d="M499.169,324.851C499.194,324.411 499.559,324.066 500,324.066C500.441,324.066 500.806,324.411 500.831,324.851L506.988,433.511L535.602,328.506C535.719,328.08 536.147,327.819 536.579,327.911C537.011,328.002 537.296,328.415 537.228,328.852L520.659,436.417L570.48,339.656C570.682,339.263 571.155,339.097 571.559,339.276C571.962,339.456 572.155,339.919 571.999,340.332L533.427,442.102L602.277,357.813C602.557,357.471 603.054,357.407 603.411,357.666C603.769,357.926 603.861,358.419 603.622,358.79L544.735,450.317L629.605,382.185C629.949,381.909 630.449,381.949 630.744,382.277C631.04,382.605 631.028,383.107 630.717,383.42L554.087,460.704L651.268,411.706C651.662,411.507 652.143,411.651 652.363,412.033C652.584,412.415 652.468,412.903 652.099,413.146L561.075,472.808L666.319,445.086C666.746,444.973 667.187,445.214 667.323,445.633C667.46,446.053 667.245,446.507 666.833,446.667L565.394,486.1L674.102,480.865C674.543,480.844 674.924,481.171 674.97,481.61C675.016,482.049 674.712,482.448 674.276,482.519L566.855,500L674.276,517.481C674.712,517.552 675.016,517.951 674.97,518.39C674.924,518.829 674.543,519.156 674.102,519.135L565.394,513.9L666.833,553.333C667.245,553.493 667.46,553.947 667.323,554.367C667.187,554.786 666.746,555.027 666.319,554.914L561.075,527.192L652.099,586.854C652.468,587.097 652.584,587.585 652.363,587.967C652.143,588.349 651.662,588.493 651.268,588.294L554.087,539.296L630.717,616.58C631.028,616.893 631.04,617.395 630.744,617.723C630.449,618.051 629.949,618.091 629.605,617.815L544.735,549.683L603.622,641.21C603.861,641.581 603.769,642.074 603.411,642.334C603.054,642.593 602.557,642.529 602.277,642.187L533.427,557.898L571.999,659.668C572.155,660.081 571.962,660.544 571.559,660.724C571.155,660.903 570.682,660.737 570.48,660.344L520.659,563.583L537.228,671.148C537.296,671.585 537.011,671.998 536.579,672.089C536.147,672.181 535.719,671.92 535.602,671.494L506.988,566.489L500.831,675.149C500.806,675.589 500.441,675.934 500,675.934C499.559,675.934 499.194,675.589 499.169,675.149L493.012,566.489L464.398,671.494C464.281,671.92 463.853,672.181 463.421,672.089C462.989,671.998 462.704,671.585 462.772,671.148L479.341,563.583L429.52,660.344C429.318,660.737 428.845,660.903 428.441,660.724C428.038,660.544 427.845,660.081 428.001,659.668L466.573,557.898L397.723,642.187C397.443,642.529 396.946,642.593 396.589,642.334C396.231,642.074 396.139,641.581 396.378,641.21L455.265,549.683L370.395,617.815C370.051,618.091 369.551,618.051 369.256,617.723C368.96,617.395 368.972,616.893 369.283,616.58L445.913,539.296L348.732,588.294C348.338,588.493 347.857,588.349 347.637,587.967C347.416,587.585 347.532,587.097 347.901,586.854L438.925,527.192L333.681,554.914C333.254,555.027 332.813,554.786 332.677,554.367C332.54,553.947 332.755,553.493 333.167,553.333L434.606,513.9L325.898,519.135C325.457,519.156 325.076,518.829 325.03,518.39C324.984,517.951 325.288,517.552 325.724,517.481L433.145,500L325.724,482.519C325.288,482.448 324.984,482.049 325.03,481.61C325.076,481.171 325.457,480.844 325.898,480.865L434.606,486.1L333.167,446.667C332.755,446.507 332.54,446.053 332.677,445.633C332.813,445.214 333.254,444.973 333.681,445.086L438.925,472.808L347.901,413.146C347.532,412.903 347.416,412.415 347.637,412.033C347.857,411.651 348.338,411.507 348.732,411.706L445.913,460.704L369.283,383.42C368.972,383.107 368.96,382.605 369.256,382.277C369.551,381.949 370.051,381.909 370.395,382.185L455.265,450.317L396.378,358.79C396.139,358.419 396.231,357.926 396.589,357.666C396.946,357.407 397.443,357.471 397.723,357.813L466.573,442.102L428.001,340.332C427.845,339.919 428.038,339.456 428.441,339.276C428.845,339.097 429.318,339.263 429.52,339.656L479.341,436.417L462.772,328.852C462.704,328.415 462.989,328.002 463.421,327.911C463.853,327.819 464.281,328.08 464.398,328.506L493.012,433.511L499.169,324.851Z"
							filter="url(#badge-shadow)"
						/>
					</g>

					<g transform="matrix(0.700633,0,0,0.700633,146.335,89.7963)">
						<circle
							className="badge-color-3-stroke"
							cx="504.778"
							cy="472.632"
							r="405"
							fill="none"
							strokeLinejoin="miter"
							strokeMiterlimit="1"
							strokeDasharray="2515 1000"
							strokeWidth="8px"
							strokeDashoffset="1100"
							filter="url(#badge-shadow)"
						/>

						<circle
							className="badge-color-3-stroke"
							cx="504.778"
							cy="472.632"
							r="388"
							fill="none"
							strokeLinejoin="miter"
							strokeMiterlimit="1"
							strokeDasharray="1500 890"
							strokeWidth="8px"
							strokeDashoffset="100"
							filter="url(#badge-shadow)"
						/>
					</g>

					<g>
						<path
							className="badge-color-1-stroke"
							d="M285.233,201.573c-56.958,57.118 -88.958,134.584 -88.958,215.359c0,168.093 136.094,304.564 303.725,304.564c167.631,0 303.725,-136.471 303.725,-304.564c0,-80.775 -32,-158.241 -88.958,-215.359c56.958,57.118 88.958,134.584 88.958,215.359c0,168.093 -136.094,304.564 -303.725,304.564c-167.631,0 -303.725,-136.471 -303.725,-304.564c0,-80.775 32,-158.241 88.958,-215.359Z"
							fill="none"
							strokeWidth="13.2px"
							filter="url(#badge-shadow)"
						/>
						<path
							className="badge-color-2-fill"
							d="M679.011,219.811c17.954,-10.654 54.668,-3.895 59.478,16.529c-22.162,13.172 -47.948,0.555 -59.478,-16.529Z"
							filter="url(#badge-shadow)"
						/>
						<path
							className="badge-color-2-fill"
							d="M321.657,219.811c-17.954,-10.654 -54.668,-3.895 -59.478,16.529c22.162,13.172 47.949,0.555 59.478,-16.529Z"
							filter="url(#badge-shadow)"
						/>
						<path
							className="badge-color-2-fill"
							d="M741.453,157.899c14.176,15.349 15.336,52.761 -3.557,61.788c-17.517,-18.943 -10.66,-46.88 3.557,-61.788Z"
							filter="url(#badge-shadow)"
						/>
						<path
							className="badge-color-2-fill"
							d="M260.503,157.899c-14.176,15.349 -15.336,52.761 3.557,61.788c17.517,-18.943 10.661,-46.88 -3.557,-61.788Z"
							filter="url(#badge-shadow)"
						/>
						<path
							className="badge-color-2-fill"
							d="M665.747,156.393c24.016,-1.386 58.058,25.022 52.208,48.498c-29.656,1.732 -49.412,-24.879 -52.208,-48.498Z"
							filter="url(#badge-shadow)"
						/>
						<path
							className="badge-color-2-fill"
							d="M336.567,158.031c-23.958,-2.18 -58.85,23.088 -53.775,46.744c29.581,2.712 50.204,-23.23 53.775,-46.744Z"
							filter="url(#badge-shadow)"
						/>
						<path
							className="badge-color-2-fill"
							d="M763.849,208.996c10.458,10.849 11.868,37.809 -1.617,44.611c-12.923,-13.39 -8.408,-33.642 1.617,-44.611Z"
							filter="url(#badge-shadow)"
						/>
						<path
							className="badge-color-2-fill"
							d="M238.665,208.996c-10.457,10.849 -11.868,37.809 1.618,44.611c12.922,-13.39 8.408,-33.642 -1.618,-44.611Z"
							filter="url(#badge-shadow)"
						/>
						<path
							className="badge-color-2-fill"
							d="M719.252,262.061c9.475,-8.96 32.751,-9.902 38.473,1.868c-11.69,11.071 -29.116,6.943 -38.473,-1.868Z"
							filter="url(#badge-shadow)"
						/>
						<path
							className="badge-color-2-fill"
							d="M282.045,261.068c-10.397,-8.664 -34.572,-8.125 -39.733,4.441c12.833,10.708 30.615,5.296 39.733,-4.441Z"
							filter="url(#badge-shadow)"
						/>
					</g>

					<g transform="matrix(-1,-1.66533e-16,1.66533e-16,-1,4149.29,841.877)">
						<path
							className="badge-color-1-fill"
							d="M3649.29,155.306C3672.84,155.306 3760.15,268.358 3760.15,268.358C3760.15,268.358 3894.27,315.282 3901.93,338.853C3909.2,361.247 3828.66,479.219 3828.66,479.219C3828.66,479.219 3825.48,621.271 3805.43,635.84C3786.38,649.679 3649.29,609.537 3649.29,609.537C3649.29,609.537 3513.21,650.408 3493.16,635.84C3474.11,622 3469.93,479.219 3469.93,479.219C3469.93,479.219 3389,362.425 3396.66,338.853C3403.94,316.46 3538.44,268.358 3538.44,268.358C3538.44,268.358 3624.51,155.306 3649.29,155.306Z"
							filter="url(#badge-shadow)"
						/>
					</g>
					<g transform="matrix(-0.784796,-1.30695e-16,1.30695e-16,-0.784796,3363.95,751.289)">
						<path
							className="badge-color-3-fill"
							d="M3649.29,155.306C3672.84,155.306 3760.15,268.358 3760.15,268.358C3760.15,268.358 3894.27,315.282 3901.93,338.853C3909.2,361.247 3828.66,479.219 3828.66,479.219C3828.66,479.219 3825.48,621.271 3805.43,635.84C3786.38,649.679 3649.29,609.537 3649.29,609.537C3649.29,609.537 3513.21,650.408 3493.16,635.84C3474.11,622 3469.93,479.219 3469.93,479.219C3469.93,479.219 3389,362.425 3396.66,338.853C3403.94,316.46 3538.44,268.358 3538.44,268.358C3538.44,268.358 3624.51,155.306 3649.29,155.306Z"
							filter="url(#badge-shadow)"
						/>
					</g>
					<g transform="matrix(-0.897814,-1.49516e-16,1.49516e-16,-0.897814,3776.39,799.461)">
						<path
							className="badge-color-3-stroke"
							d="M3649.29,155.306C3672.84,155.306 3760.15,268.358 3760.15,268.358C3760.15,268.358 3894.27,315.282 3901.93,338.853C3909.2,361.247 3828.66,479.219 3828.66,479.219C3828.66,479.219 3825.48,621.271 3805.43,635.84C3786.38,649.679 3649.29,609.537 3649.29,609.537C3649.29,609.537 3513.21,650.408 3493.16,635.84C3474.11,622 3469.93,479.219 3469.93,479.219C3469.93,479.219 3389,362.425 3396.66,338.853C3403.94,316.46 3538.44,268.358 3538.44,268.358C3538.44,268.358 3624.51,155.306 3649.29,155.306Z"
							fill="none"
							strokeWidth="2.97px"
							strokeLinejoin="miter"
							strokeMiterlimit="1"
							filter="url(#badge-shadow)"
						/>
					</g>
					<g transform="matrix(-0.833069,-1.38734e-16,1.38734e-16,-0.833069,3540.11,772.207)">
						<path
							className="badge-color-3-stroke"
							d="M3649.29,155.306C3672.84,155.306 3760.15,268.358 3760.15,268.358C3760.15,268.358 3894.27,315.282 3901.93,338.853C3909.2,361.247 3828.66,479.219 3828.66,479.219C3828.66,479.219 3825.48,621.271 3805.43,635.84C3786.38,649.679 3649.29,609.537 3649.29,609.537C3649.29,609.537 3513.21,650.408 3493.16,635.84C3474.11,622 3469.93,479.219 3469.93,479.219C3469.93,479.219 3389,362.425 3396.66,338.853C3403.94,316.46 3538.44,268.358 3538.44,268.358C3538.44,268.358 3624.51,155.306 3649.29,155.306Z"
							fill="none"
							strokeWidth="3.2px"
							strokeLinejoin="miter"
							strokeMiterlimit="1"
							filter="url(#badge-shadow)"
						/>
					</g>
					<g transform="matrix(1.02187,0,0,1.02187,-3229.09,-8.4616)">
						<path
							className="badge-color-2-fill"
							d="M3646.14,71.242C3646.74,70.053 3647.96,69.304 3649.29,69.304C3650.63,69.304 3651.85,70.053 3652.45,71.242C3665.33,96.728 3713.55,192.144 3719.15,203.237C3719.5,203.921 3719.61,204.699 3719.48,205.453C3717.24,217.915 3697.67,326.939 3692.43,356.165C3692.19,357.498 3692.73,358.85 3693.83,359.646C3694.92,360.442 3696.38,360.541 3697.57,359.902C3723.74,345.881 3821.38,293.579 3832.54,287.601C3833.22,287.239 3833.99,287.106 3834.75,287.224C3847.03,289.128 3952.68,305.505 3980.9,309.879C3982.22,310.083 3983.31,311.01 3983.72,312.277C3984.13,313.544 3983.79,314.935 3982.85,315.874C3962.59,335.999 3886.75,411.346 3877.93,420.106C3877.38,420.646 3876.68,420.995 3875.92,421.099C3863.38,422.823 3753.64,437.901 3724.22,441.943C3722.88,442.127 3721.77,443.062 3721.35,444.35C3720.93,445.638 3721.28,447.051 3722.26,447.989C3743.68,468.549 3823.6,545.249 3832.73,554.016C3833.29,554.547 3833.65,555.243 3833.77,556C3835.76,568.269 3852.83,673.807 3857.39,701.996C3857.6,703.311 3857.06,704.634 3855.98,705.417C3854.9,706.2 3853.47,706.31 3852.29,705.701C3826.89,692.654 3731.79,643.805 3720.74,638.125C3720.06,637.775 3719.51,637.213 3719.17,636.523C3713.66,625.126 3665.41,525.421 3652.47,498.693C3651.88,497.474 3650.65,496.7 3649.29,496.7C3647.94,496.7 3646.7,497.474 3646.12,498.693C3633.18,525.421 3584.93,625.126 3579.41,636.523C3579.08,637.213 3578.53,637.775 3577.85,638.125C3566.79,643.805 3471.7,692.654 3446.3,705.701C3445.11,706.31 3443.69,706.2 3442.61,705.417C3441.53,704.634 3440.99,703.311 3441.2,701.996C3445.76,673.807 3462.83,568.269 3464.81,556C3464.94,555.243 3465.3,554.547 3465.86,554.016C3474.99,545.249 3554.9,468.549 3576.33,447.989C3577.3,447.051 3577.66,445.638 3577.24,444.35C3576.82,443.062 3575.7,442.127 3574.36,441.943C3544.95,437.901 3435.21,422.823 3422.67,421.099C3421.91,420.995 3421.2,420.646 3420.66,420.106C3411.84,411.346 3336,335.999 3315.74,315.874C3314.79,314.935 3314.46,313.544 3314.87,312.277C3315.28,311.01 3316.37,310.083 3317.69,309.879C3345.91,305.505 3451.55,289.128 3463.84,287.224C3464.59,287.106 3465.37,287.239 3466.04,287.601C3477.2,293.579 3574.85,345.881 3601.02,359.902C3602.21,360.541 3603.67,360.442 3604.76,359.646C3605.86,358.85 3606.4,357.498 3606.16,356.165C3600.92,326.939 3581.35,217.915 3579.11,205.453C3578.97,204.699 3579.09,203.921 3579.43,203.237C3585.04,192.144 3633.26,96.728 3646.14,71.242Z"
							filter="url(#badge-shadow)"
						/>
					</g>
					<g transform="matrix(1.04948,4.66062e-16,-4.66062e-16,1.04948,-3329.86,-20.8275)">
						<path
							className="badge-color-3-fill"
							d="M3646.99,109.736C3647.12,108.562 3648.11,107.673 3649.29,107.673C3650.48,107.673 3651.47,108.562 3651.6,109.736L3678.02,347.849C3678.85,355.309 3682.78,362.074 3688.86,366.486C3694.93,370.897 3702.58,372.547 3709.93,371.029L3944.55,322.579C3945.71,322.34 3946.86,323.01 3947.23,324.134C3947.59,325.258 3947.05,326.477 3945.98,326.964L3727.68,425.676C3720.85,428.769 3715.63,434.599 3713.31,441.737C3710.99,448.875 3711.78,456.66 3715.5,463.182L3834.08,671.351C3834.66,672.378 3834.38,673.681 3833.43,674.375C3832.47,675.07 3831.14,674.935 3830.35,674.061L3669.01,496.956C3663.96,491.407 3656.8,488.245 3649.29,488.245C3641.79,488.245 3634.63,491.407 3629.58,496.956L3468.24,674.061C3467.44,674.935 3466.12,675.07 3465.16,674.375C3464.2,673.681 3463.92,672.378 3464.51,671.351L3583.09,463.182C3586.81,456.66 3587.6,448.875 3585.28,441.737C3582.96,434.599 3577.74,428.769 3570.9,425.676L3352.61,326.964C3351.53,326.477 3350.99,325.258 3351.36,324.134C3351.73,323.01 3352.88,322.34 3354.04,322.579L3588.66,371.029C3596.01,372.547 3603.66,370.897 3609.73,366.486C3615.8,362.074 3619.74,355.309 3620.56,347.849L3646.99,109.736Z"
							filter="url(#badge-shadow)"
						/>
					</g>
					<g transform="matrix(0.765413,3.39912e-16,-3.39912e-16,0.765413,-2293.22,98.7466)">
						<path
							className="badge-color-4-fill"
							d="M3646.99,109.736C3647.12,108.562 3648.11,107.673 3649.29,107.673C3650.48,107.673 3651.47,108.562 3651.6,109.736L3678.02,347.849C3678.85,355.309 3682.78,362.074 3688.86,366.486C3694.93,370.897 3702.58,372.547 3709.93,371.029L3944.55,322.579C3945.71,322.34 3946.86,323.01 3947.23,324.134C3947.59,325.258 3947.05,326.477 3945.98,326.964L3727.68,425.676C3720.85,428.769 3715.63,434.599 3713.31,441.737C3710.99,448.875 3711.78,456.66 3715.5,463.182L3834.08,671.351C3834.66,672.378 3834.38,673.681 3833.43,674.375C3832.47,675.07 3831.14,674.935 3830.35,674.061L3669.01,496.956C3663.96,491.407 3656.8,488.245 3649.29,488.245C3641.79,488.245 3634.63,491.407 3629.58,496.956L3468.24,674.061C3467.44,674.935 3466.12,675.07 3465.16,674.375C3464.2,673.681 3463.92,672.378 3464.51,671.351L3583.09,463.182C3586.81,456.66 3587.6,448.875 3585.28,441.737C3582.96,434.599 3577.74,428.769 3570.9,425.676L3352.61,326.964C3351.53,326.477 3350.99,325.258 3351.36,324.134C3351.73,323.01 3352.88,322.34 3354.04,322.579L3588.66,371.029C3596.01,372.547 3603.66,370.897 3609.73,366.486C3615.8,362.074 3619.74,355.309 3620.56,347.849L3646.99,109.736Z"
							filter="url(#badge-shadow)"
						/>
					</g>

					<g className="badge-iron">
						<circle
							cx="504.778"
							cy="472.632"
							r="221.546"
							fill="url(#badge-iron-gradient)"
							transform="translate(84.3 31.712) scale(.82353)"
							filter="url(#badge-circle-shadow)"
						/>
					</g>
					<g className="badge-bronze">
						<circle
							cx="504.778"
							cy="472.632"
							r="221.546"
							fill="url(#badge-bronze-gradient)"
							transform="translate(84.3 31.712) scale(.82353)"
							filter="url(#badge-circle-shadow)"
						/>
					</g>
					<g className="badge-silver">
						<circle
							cx="504.778"
							cy="472.632"
							r="221.546"
							fill="url(#badge-silver-gradient)"
							transform="translate(84.3 31.712) scale(.82353)"
							filter="url(#badge-circle-shadow)"
						/>
					</g>
					<g className="badge-gold">
						<circle
							cx="504.778"
							cy="472.632"
							r="221.546"
							fill="url(#badge-gold-gradient)"
							transform="translate(84.3 31.712) scale(.82353)"
							filter="url(#badge-circle-shadow)"
						/>
					</g>
					<g className="badge-titanium">
						<circle
							cx="504.778"
							cy="472.632"
							r="221.546"
							fill="url(#badge-titanium-gradient)"
							transform="translate(84.3 31.712) scale(.82353)"
							filter="url(#badge-circle-shadow)"
						/>
					</g>

					<g transform="matrix(0.700633,0,0,0.700633,146.335,89.7963)">
						<circle
							className="badge-color-3-stroke"
							cx="504.778"
							cy="472.632"
							r="251"
							fill="none"
							strokeWidth="3.81px"
							strokeLinejoin="miter"
							strokeMiterlimit="1"
							filter="url(#badge-shadow)"
						/>
						<circle
							className="badge-color-3-stroke"
							cx="504.778"
							cy="472.632"
							r="236"
							fill="none"
							strokeWidth="7px"
							strokeLinejoin="miter"
							strokeMiterlimit="1"
							filter="url(#badge-shadow)"
						/>
						<circle
							className="badge-color-3-stroke"
							cx="504.778"
							cy="472.632"
							r="221.546"
							fill="none"
							strokeWidth="3.81px"
							strokeLinejoin="miter"
							strokeMiterlimit="1"
							filter="url(#badge-shadow)"
						/>
					</g>
				</g>
			</g>
		</g>
		<defs>
			<filter id="badge-circle-shadow" x="-50%" y="-50%" width="200%" height="200%">
				<feOffset result="offOut" in="SourceAlpha" />
				<feGaussianBlur result="blurOut" in="offOut" stdDeviation="10" />
				<feComponentTransfer>
					<feFuncA type="linear" slope=".5" />
				</feComponentTransfer>
				<feMerge>
					<feMergeNode />
					<feMergeNode in="SourceGraphic" />
				</feMerge>
			</filter>
			<filter id="badge-shadow" x="-50%" y="-50%" width="200%" height="200%">
				<feOffset result="offOut" in="SourceAlpha" />
				<feGaussianBlur result="blurOut" in="offOut" stdDeviation="5" />
				<feComponentTransfer>
					<feFuncA type="linear" slope=".2" />
				</feComponentTransfer>
				<feMerge>
					<feMergeNode />
					<feMergeNode in="SourceGraphic" />
				</feMerge>
			</filter>

			<linearGradient id="badge-iron-gradient" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-90 599.4785 94.7005) scale(443.093)">
				<stop offset="0" stopColor="#59707b" />
				<stop offset="1" stopColor="#bcc8ce" />
			</linearGradient>

			<linearGradient id="badge-bronze-gradient" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-90 599.4785 94.7005) scale(443.093)">
				<stop offset="0" stopColor="#823221" />
				<stop offset="1" stopColor="#d07349" />
			</linearGradient>

			<linearGradient id="badge-silver-gradient" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-90 599.4785 94.7005) scale(443.093)">
				<stop offset="0" stopColor="#938b87" />
				<stop offset="1" stopColor="#d8d5d3" />
			</linearGradient>

			<linearGradient id="badge-gold-gradient" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-90 599.4785 94.7005) scale(443.093)">
				<stop offset="0" stopColor="#b17c43" />
				<stop offset="1" stopColor="#ebce67" />
			</linearGradient>

			<linearGradient id="badge-titanium-gradient" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-90 599.4785 94.7005) scale(443.093)">
				<stop offset="0" stopColor="#1c1c1c" />
				<stop offset="1" stopColor="#404040" />
			</linearGradient>
		</defs>
	</svg>
)
